/**
 * Setup gate for an authenticated user landing in the app.
 *
 * Org-less users hit the `/setup/workspace` invite wall (self-serve creation is
 * closed). Everyone with an org goes straight in — the onboarding wizard was
 * removed, so there is no `onboarding_completed` gate anymore. An org-less LATO
 * platform admin (verified via `/users/me`) has no workspace to show, so they
 * land in Admin, where they manage every organization's studies directly.
 */
export function setupRedirect(opts: {
  staff: boolean;
  hasOrg: boolean;
}): "/setup/workspace" | "/admin/studies" | null {
  if (opts.hasOrg) return null;
  return opts.staff ? "/admin/studies" : "/setup/workspace";
}
